import { first } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import { userDelineationSelector } from '../selectors/delineation.selectors';
import { Delineation } from '../types/delineation.type';
import { pickDelineation } from './pick-delineation.thunk';
import * as delineationActions from '../actions/delineation.actions';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { filterDelineations } from '../utils/delineation.utils';
import { importDelineation } from './import-delineation.thunk';
import * as waveActions from '../../wave/actions/wave.actions';
import { trackImportDelineation } from '../../analytics/thunks/track-import-delineation.thunk';

export const loadDelineations =
  (existingDelineations: Delineation[]): AppThunk =>
  async (dispatch, getState) => {
    if (existingDelineations == null || existingDelineations.length === 0) {
      return;
    }
    const autoImportDelineation = booleanPreferenceSelector(
      'autoImportDelineation',
    )(getState());
    const filteredDelineations = filterDelineations(
      existingDelineations,
      getState,
    );

    if (filteredDelineations.length === 0) {
      return;
    }

    dispatch(
      delineationActions.load({
        delineations: filteredDelineations,
        meta: { history: false },
      }),
    );

    const firstDelineation = first(filteredDelineations);

    if (firstDelineation == null) {
      return;
    }
    const userDelineation = userDelineationSelector(getState());
    const id = userDelineation?.id ?? firstDelineation.id;
    await dispatch(pickDelineation(id, true));

    if (userDelineation != null) {
      dispatch(delineationActions.markAsSaved());
      const updatedUserDelineation = userDelineationSelector(getState()); // we fetch again the user delineation now that it has fetched the waves and filtered them
      dispatch(
        waveActions.setSavedWaves({
          waves: updatedUserDelineation?.waves ?? [],
        }),
      );
    } else if (autoImportDelineation) {
      dispatch(trackImportDelineation('auto_import'));
      dispatch(importDelineation(firstDelineation.id));
    }
  };
